<!-- 报表查询组件 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-form @submit.native.prevent :inline="true" label-width="100px" ref="getRequestData" :model="getRequestData" class="demo-form-inline dis" size="mini" v-if="reportConditionVos.length > 0" :show-message="false">
                    <template v-for="(formOneValue, formOneKey) in reportConditionVos">
                        <el-form-item :prop="formOneValue.fieldEntity" :rules="[{ required: formOneValue.isReq == 1 || formOneValue.fieldEntity == 'bgmName' || formOneValue.fieldEntity == 'batchno', trigger: ['blur', 'change'] }]"
                            :label="formOneValue.fieldShow" class="pd" :key="formOneKey" v-if="formOneValue.isShow == 1">
                            <label slot="label" :style="$common.labelStyle(formOneValue.fieldShow)" v-html="$common.htmlLabel(formOneValue.fieldShow)"></label>
                            <el-input class="form_codition" @input="$forceUpdate()" clearable style="width:200px" v-if="formOneValue.fieldType == 'string'" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                                :placeholder="'请输入' + formOneValue.fieldShow" v-model.trim="getRequestData[formOneValue.fieldEntity]" size="mini">
                            </el-input>
                            <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'start' || formOneValue.fieldEntity == 'start2'" size="mini" v-model="getRequestData[formOneValue.fieldEntity]" format="yyyy年MM月dd日"
                                value-format="timestamp" type="date" placeholder="选择日期">
                            </el-date-picker>
                            <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'end' ||
                            formOneValue.fieldEntity == 'end2'" @change="changeTime" size="mini" @focus="timeFocus(formOneValue.fieldEntity)" v-model="getRequestData[formOneValue.fieldEntity]" format="yyyy年MM月dd日" value-format="timestamp"
                                type="date" placeholder="选择日期">
                            </el-date-picker>
                            <el-input class="form_codition" @input="$forceUpdate()" style="width:200px" type="number" v-else-if="formOneValue.fieldType == 'number'" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                                :placeholder="'请输入' + formOneValue.fieldShow" v-model.number="getRequestData[formOneValue.fieldEntity]" size="mini">
                            </el-input>
                            <el-input class="form_codition" @input="$forceUpdate()" v-else-if="formOneValue.fieldType == 'search'" @change="claerValue(formOneValue.fieldEntity, formOneValue.paramField)"
                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.fieldEntity, formOneValue.paramField)" clearable v-model="getRequestData[formOneValue.fieldEntity]">
                                <el-button @click="openSearch(formOneValue.searchId, formOneValue.fieldEntity, formOneValue.paramField)" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                            <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @change="$forceUpdate()" v-model="getRequestData[formOneValue.fieldEntity]" placeholder="请选择">
                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                                </el-option>
                            </el-select>
                            <el-input class="form_codition" clearable v-else v-model.trim="getRequestData[formOneValue.fieldEntity]" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })" @input="$forceUpdate()"
                                @keyup.enter.native="searchData('getRequestData')">
                            </el-input>
                        </el-form-item>
                    </template>
                    <el-form-item class="pd">
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData('getRequestData')">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <!-- 工具栏：对齐 dataQueryTemplate / v-tabs 主题 -->
        <div v-if="reportModuleVos.length > 0" class="module_toolbar">
            <div class="module_toolbar_left">
                <span class="report_name">进销存流向查询（新）</span>
            </div>
            <ul class="ul_btn">
                <li>
                    <el-tooltip effect="dark" content="刷新" placement="top">
                        <i class="el-icon-refresh icons" @click="getPageInfo()"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip effect="dark" content="汇总" placement="top">
                        <i class="el-icon-s-data icons" @click="recordSummary"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip effect="dark" content="过滤" placement="top">
                        <i class="el-icon-edit-outline icons" @click="recordFiltering"></i>
                    </el-tooltip>
                </li>
                <li v-if="opmExport == 1">
                    <el-tooltip effect="dark" content="导出" placement="top">
                        <i class="el-icon-download icons" @click="exportData"></i>
                    </el-tooltip>
                </li>
                <li v-if="isPrint == 1">
                    <el-tooltip effect="dark" content="打印" placement="top">
                        <i class="el-icon-printer icons" @click="showPrintPlan"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip effect="dark" content="设置" placement="top">
                        <i class="el-icon-setting icons" @click="openFormDesign"></i>
                    </el-tooltip>
                </li>
            </ul>
        </div>
        <div v-if="reportModuleVos.length > 0" class="page_content_center multi_module_wrap" v-loading="fullscreenLoading">
            <div v-for="(module, moduleIndex) in reportModuleVos" :key="module.rpmId || moduleIndex" class="module_block">
                <div class="module_header">
                    <span class="module_title">{{ module.rpmName }}</span>
                    <span class="module_count">共 {{ (moduleDataList[moduleIndex] || []).length }} 条</span>
                </div>
                <u-table :cell-style="tableRowStyleName" highlight-current-row size="mini" :ref="'tableRef'" :show-summary="totalField.length > 0" :row-style="rowStyle" :summary-method="getSummaries" :row-class-name="tableRowClassName"
                    :data="moduleDataList[moduleIndex] || []" border style="width: 100%" row-key="index">
                    <u-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </u-table-column>
                    <template v-for="(tableValye, tableKey) in module.desysReportTableVos">
                        <u-table-column align="center" :key="moduleIndex + '-' + tableKey" show-overflow-tooltip v-if="tableValye.isShow == 1" :min-width="tableValye.fieldWeight" :prop="tableValye.fieldEntity" :label="tableValye.fieldShow"
                            :sortable="tableValye.isSort == 1 ? true : false">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.fieldEntity]">
                                    {{ $common.getLocalTime(scope.row[tableValye.fieldEntity]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.fieldEntity]">
                                    {{ $common.getLocalTime(scope.row[tableValye.fieldEntity], true) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'formatter'">
                                    <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                        <el-tag size="mini" v-if="item.key == scope.row[tableValye.fieldEntity]">
                                            {{ item.value }}
                                        </el-tag>
                                    </span>
                                </span>
                                <span v-else-if="tableValye.fieldEntity == 'createTime' && scope.row[tableValye.fieldEntity]">
                                    {{ $common.getLocalTime(scope.row[tableValye.fieldEntity], true) }}
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.fieldEntity]
                                }}</a>
                                </span>
                                <span v-else>
                                    {{ scope.row[tableValye.fieldEntity] }}
                                </span>
                            </template>
                        </u-table-column>
                    </template>
                </u-table>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <recordSummary ref="recordSummary"></recordSummary>
        <recordFiltering ref="recordFiltering"></recordFiltering>
        <customDesignReport ref="customDesignReport"></customDesignReport>
    </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import XLSX from 'xlsx';
function workbook2blob(workbook) {
    // 生成excel的配置项
    var wopts = {
        // 要生成的文件类型
        bookType: "xlsx",
        // // 是否生成Shared String Table，官方解释是，若是开启生成速度会降低，但在低版本IOS设备上有更好的兼容性
        bookSST: false,
        type: "binary"
    };
    var wbout = XLSX.write(workbook, wopts);
    // 将字符串转ArrayBuffer
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }
    var blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
    });
    return blob;
}
function openDownloadDialog(blob, fileName) {
    if (typeof blob == "object" && blob instanceof Blob) {
        blob = URL.createObjectURL(blob); // 建立blob地址
    }
    var aLink = document.createElement("a");
    aLink.href = blob;
    // HTML5新增的属性，指定保存文件名，能够不要后缀，注意，有时候 file:///模式下不会生效
    aLink.download = fileName || "";
    var event;
    if (window.MouseEvent) event = new MouseEvent("click");
    // 移动端
    else {
        event = document.createEvent("MouseEvents");
        event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    }
    aLink.dispatchEvent(event);
}
export default {
    name: "inOutFlowDirectionListNew",
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            tableHeigh: 0,
            getRequestData: {
                start: "",
                end: "",
                sql: "",
                ormId: "",
            },
            table1: [],
            table2: [],
            table3: [],
            reportName: '',
            rpcId: '',
            fullscreenLoading: false,
            activeName: "report0",
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            reportConditionVos: [],
            reportModuleVos: [],
            dataList: [],
            tabIndex: 0,
            list: [],
            // 各模块表格数据（上下结构，一一对应 reportModuleVos）
            moduleDataList: [],
            excelData: [],
            rpmName: "",
            searchField: "",
            paramField: "",
            parentSearchData: {},
            isJxqPrint: false,
            totalField: [],
            numberField: [],
            stringField: [],
            isOpmParam: false,
            timeField: '',
            opmExport: 0,
            isPrint: 0,
            allData: {}
        };
    },
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        getPageInfo() {
            this.reportModuleVos = []
            this.getFormList()
        },
        openFormDesign() {
            var pageShowData = {
                reportConditionVos: this.reportConditionVos,
                reportModuleVos: this.reportModuleVos,
            }
            this.$refs['customDesignReport'].openBox(this.rpcId, pageShowData, this.reportName)
        },
        tableRowStyleName({ row }) {
            if (row.color) return `background-color: ${row.color} !important;`;
        },
        timeFocus(e) {
            this.timeField = e
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData[this.timeField] = time;
            }
        },
        // 记录汇总（默认对第一个模块）
        recordSummary() {
            this.numberField = []
            this.stringField = []
            let nowFieldJur = this.reportModuleVos[0].desysReportTableVos
            let rpcName = this.reportModuleVos[0].rpmName;
            nowFieldJur.forEach((key) => {
                if (key.isShow == 0) return
                if (key.fieldType == 'number') {
                    this.numberField.push(key)
                    return
                }
                this.stringField.push(key)
            })
            let sendData = {
                numberField: this.numberField,
                stringField: this.stringField,
                list: this.moduleDataList[0] || [],
                rpcName: rpcName
            }
            this.$refs.recordSummary.openBox(sendData)
        },
        // 记录过滤（默认对第一个模块）
        recordFiltering() {
            let nowFieldJur = this.reportModuleVos[0].desysReportTableVos
            let rpcName = this.reportModuleVos[0].rpmName;
            let sendData = {
                nowFieldJur: nowFieldJur,
                list: this.moduleDataList[0] || [],
                rpcName: rpcName
            }
            this.$refs.recordFiltering.openBox(sendData)
        },
        toDecimal(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return;
            }
            f = Math.round(x * 100) / 100;
            return f;
        },
        // 自定义合计字段
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.totalField.includes(column.property)) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.toDecimal(prev + curr);
                            } else {
                                return this.toDecimal(prev)
                            }
                        }, 0);
                        sums[index] = this.$common.getDecimalInfo(3, sums[index])
                        // sums[index] = sums[index].toFixed(2)
                        // sums[index] += ' 元';
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = ''
                }
            });

            return [sums];
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, field, paramField) {
            console.log(sId, field, paramField);
            if (field == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.searchField = field;
            this.paramField = paramField;
            this.DialogVisible = true;
            this.seId = sId;
            console.log(field, this.getRequestData.smId)

            this.parentSearchData[field] = this.getRequestData[field];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.paramField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(paramField) {
            let arr = paramField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.getRequestData[this.searchField] = val[this.searchField];
                // this.getRequestData[this.paramField] = val[this.paramField];
                this.paramValue(val)
            }
        },
        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            // if (row.color) return row.color;
        },
        toDetail(orderId) {
            // console.log(orderId)
            this.$parent.toDetail(orderId);
        },
        dealTime(shijianchuo) {
            var time = new Date(shijianchuo);
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            return y + '年' + m + '月' + d + '日'
        },
        async getAllData(index) {
            this.getRequestData.ormId = JSON.parse(
                sessionStorage.getItem("loginInfo")
            ).ormId;
            if (this.getRequestData.hasOwnProperty("opmId") && !this.isOpmParam) {
                this.getRequestData.opmId = JSON.parse(
                    sessionStorage.getItem("userInfo")
                ).opmId;
            }
            this.getRequestData.rpmId =
                this.reportModuleVos[index].rpmId;
            for (let key in this.getRequestData) {
                if (this.isNull(this.getRequestData[key])) this.getRequestData[key] = ''
            }
            let responseData = await this.$http.getReportDataById(
                this.getRequestData
            );
            if (responseData.status == 200) {
                return responseData.rows;
                // this.fullscreenLoading = false
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async showPrintPlan() {
            console.log(this.reportModuleVos);
            var table1 = [], table2 = [], table3 = [], table4 = []
            var table = []
            if (this.reportModuleVos.length == 3) {
                table1 = await this.getAllData(0)
                table2 = await this.getAllData(1)
                table3 = await this.getAllData(2)
                table = [table1, table2, table3]
            } else if (this.reportModuleVos.length == 4) {
                table1 = await this.getAllData(0)
                table2 = await this.getAllData(1)
                table3 = await this.getAllData(2)
                table4 = await this.getAllData(3)
                table = [table1, table2, table3, table4]
            }
            var obj = JSON.parse(JSON.stringify(this.getRequestData))
            //数据列表
            if (obj.start && obj.end) {
                this.$set(obj, 'start', this.dealTime(obj.start))
                this.$set(obj, 'end', this.dealTime(obj.end))
            }
            if (obj.start2 && obj.end2) {
                this.$set(obj, 'start2', this.dealTime(obj.start2))
                this.$set(obj, 'end2', this.dealTime(obj.end2))
            }
            if (obj.bgmId == '') delete obj.bgmId
            if (obj.page) delete obj.page
            if (obj.smId == '') delete obj.smId
            const sxobj = {}
            this.reportConditionVos.forEach(item => {
                sxobj[item.fieldEntity] = item.fieldShow
            })
            const userdataList = []
            for (let i = 0; i < this.reportModuleVos.length; i++) {
                const obj = {}
                this.reportModuleVos[i].desysReportTableVos.forEach(item => {
                    obj[item.fieldEntity] = item.fieldShow
                })
                const toDealTime = []
                const toDealTime1 = []
                this.reportModuleVos[i].desysReportTableVos.forEach(item => {
                    if (item.fieldType == 'date') {
                        toDealTime.push(item.fieldEntity)
                    }
                    if (item.fieldType == 'datetime') {
                        toDealTime.push(item.fieldEntity)
                    }
                })
                const cloneList = table[i]
                console.log(cloneList);
                const dataList = cloneList.map(item => {
                    toDealTime.forEach(item2 => {
                        if (Object.keys(item).includes(item2)) {
                            item[item2] = this.$common.getLocalTime(item[item2])
                        }
                    })
                    toDealTime1.forEach(item2 => {
                        if (Object.keys(item).includes(item2)) {
                            item[item2] = this.$common.getLocalTime(item[item2], true)
                        }
                    })
                    return item
                })
                userdataList.push({
                    "rowcount": dataList.length,
                    "rows": dataList,
                    "cols": obj,
                    "tableName": this.reportModuleVos[i].rpmName
                })
            }
            //表格信息（表格名表格数据条数等）
            console.log(userdataList);
            //过滤条件
            var jomsg = {
                "scheme": "print",
                "data": {
                    "route": "design",
                    "param": {
                        "reportkey": sessionStorage.getItem('printJurId'),
                        "reportname": this.reportModuleVos[0].rpmName,
                        "reportmod": "",
                        "variables": {},
                        "ShowPrintDialog": true,
                        "PrintCopys": 1,
                        "userdata": [
                            ...userdataList, {
                                "rowcount": 1,
                                "rows": [obj],
                                "cols": sxobj,
                                "tableName": "查询条件"
                            }
                        ]
                    }
                }
            }
            console.log(jomsg);
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                let printSource = sessionStorage.getItem('printSource').replace(/\"/g, "")
                // 选中的数据
                this.$refs.printPlan.openDia('报表打印', printSource, sessionStorage.getItem('printJurId'), '', '', obj, '', jomsg)
            } else {
                return
            }
            //打印数据


        },
        //触发按钮点击下载事件
        exportData() {
            //将你要导出的数组数据（historyList）赋值给excelDate
            this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
        },
        //表格数据写入excel
        async export2Excel() {
            console.log(this.reportModuleVos);

            // 批量获取所有模块的数据
            const moduleDataPromises = this.reportModuleVos.map((module, index) => this.getAllData(index));
            const allModuleData = await Promise.all(moduleDataPromises);

            // 创建工作簿
            let wb = XLSX.utils.book_new();

            // 并行处理每个模块
            await Promise.all(this.reportModuleVos.map(async (module, i) => {
                const excelData = allModuleData[i];
                var listBeiFen = JSON.parse(JSON.stringify(excelData));

                // 处理字段类型
                var timeList = []; // date类型的字段 导出之前进行格式转换
                var timeList1 = []; // date类型的字段 导出之前进行格式转换
                var formatterList = []; // "formatter"类型字段，格式转换
                let formatterSel = [];

                // 循环当前tab表格信息
                module.desysReportTableVos.forEach((item) => {
                    // 如果为date类型push
                    if (item.fieldType == "date") {
                        timeList.push(item.fieldEntity);
                    }
                    if (item.fieldType == "datetime") {
                        timeList1.push(item.fieldEntity);
                    }
                    // 如果date类型为"formatter"
                    if (item.fieldType == "formatter") {
                        formatterSel.push(item.formatterContent)
                        formatterList.push(item.fieldEntity)
                    }
                });
                // 循环数据列表和时间字段数组 进行转换
                listBeiFen.forEach((item) => {
                    timeList.forEach((timeitem) => {
                        if (item[timeitem]) {
                            let fmDate = this.$common.getLocalTime(item[timeitem]);
                            item[timeitem] = fmDate.indexOf('-') > -1 ? fmDate : "";
                        } else {
                            item[timeitem] = "";
                        }
                    });
                });
                // 循环数据列表和时间字段数组 进行转换
                listBeiFen.forEach((item) => {
                    timeList1.forEach((timeitem) => {
                        if (item[timeitem]) {
                            let fmDate = this.$common.getLocalTime(item[timeitem], true);
                            item[timeitem] = fmDate.indexOf('-') > -1 ? fmDate : "";
                        } else {
                            item[timeitem] = "";
                        }
                    });
                });
                console.log(formatterSel, formatterList, "C测试");

                listBeiFen.forEach((item) => {
                    formatterList.forEach((val, key) => {
                        if (item[val] != null) {
                            item[val] = this.getValue(item[val], val, 'formatter', formatterSel[key])
                        }
                    })
                });

                // 处理总数字段
                const totalField = [...this.totalField];
                const kpsjIndex = totalField.findIndex(item => item == 'kpsj');
                if (kpsjIndex > -1) {
                    totalField.splice(kpsjIndex, 1);
                }
                const kpyIndex = totalField.findIndex(item => item == 'kpy');
                if (kpyIndex > -1) {
                    totalField.splice(kpyIndex, 1);
                }

                totalField.forEach(item => {
                    listBeiFen.forEach(key => {
                        key[item] = Number(key[item]);
                    });
                });
                // 转换数据格式
                const sheetData = listBeiFen.map(items => {
                    const obj = {};
                    module.desysReportTableVos.forEach(item => {
                        if (item.isShow) {
                            obj[item.fieldShow] = items[item.fieldEntity];
                        }
                    });
                    return obj;
                });

                // 创建sheet并添加到工作簿
                const sheet = XLSX.utils.json_to_sheet(sheetData);
                XLSX.utils.book_append_sheet(wb, sheet, module.rpmName);
            }));

            const workbookBlob = workbook2blob(wb);
            // 导出总表
            openDownloadDialog(workbookBlob, '进销存流向.xlsx');
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            var value = ""
            if (String(Number(val)) != NaN) {
                value = Number(val)
            } else {
                value = val
            }
            if (fieldType == 'formatter') {
                if (arr && arr != null && arr != '') {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && Number(item.value) === value) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && Number(item.key) === value) {
                            str = item.value
                        } else {
                            if (item.value == value) {
                                str = item.key
                            } else if (item.key == value) {
                                str = item.value
                            }
                        }
                    })
                }
            } else {
                str = val || ""
            }

            return String(str)
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.getRequestData[name] = value;
            this.$forceUpdate()
        },
        // 数据搜索
        searchData(getRequestData) {
            // 查询条件表单校验
            this.$refs[getRequestData].validate((valid) => {
                if (valid) {
                    this.getDataList();
                } else {
                    return this.$message({
                        message: "请完善查询条件",
                        type: "warning",
                    });
                }
            });
        },
        isNull(value) {
            if (!value && typeof value != "undefined" && value != 0) {
                return true;
            }
            return false;
        },
        // 获取数据列表（一次拉取全部模块，上下结构展示）
        async getDataList() {
            this.fullscreenLoading = true;
            try {
                this.getRequestData.ormId = JSON.parse(
                    sessionStorage.getItem("loginInfo")
                ).ormId;
                if (this.getRequestData.hasOwnProperty("opmId") && !this.isOpmParam) {
                    this.getRequestData.opmId = JSON.parse(
                        sessionStorage.getItem("userInfo")
                    ).opmId;
                }
                for (let key in this.getRequestData) {
                    if (this.isNull(this.getRequestData[key])) this.getRequestData[key] = ''
                }
                const moduleDataPromises = this.reportModuleVos.map(async (module) => {
                    const requestData = Object.assign({}, this.getRequestData, {
                        rpmId: module.rpmId
                    });
                    let responseData = await this.$http.getReportDataById(requestData);
                    if (responseData.status == 200) {
                        return responseData.rows || [];
                    }
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                    return [];
                });
                this.moduleDataList = await Promise.all(moduleDataPromises);
                this.list = this.moduleDataList[0] || [];
            } finally {
                this.fullscreenLoading = false;
            }
        },
        // 获取对应表单数据 渲染查询条件和表格头
        async getFormList() {
            let id = sessionStorage.getItem("reportId");
            const responseData = await this.$http.getUserReportPlanById({ ids: [id] })
            let reportData = responseData.result
            this.allData = reportData
            console.log('reportData', reportData)
            this.reportName = reportData.rpcName
            this.rpcId = reportData.rpcId
            // 打印记录 导出记录 操作人检索方案 opmBuyer=''
            if (reportData.rpcId == "34707544182784" || reportData.rpcId == "35470962036736") this.parentSearchData.opmBuyer = '';
            this.opmExport = JSON.parse(sessionStorage.getItem('userInfo')).opmExport
            this.isPrint = JSON.parse(sessionStorage.getItem('userInfo')).isPrint
            this.reportConditionVos = reportData.reportConditionVos; // 检索条件
            this.reportModuleVos = reportData.reportModuleVos; // 表格头
            this.moduleDataList = this.reportModuleVos.map(() => []);
            this.totalField = []
            this.reportModuleVos.forEach((item) => {
                item.desysReportTableVos.forEach((key) => {
                    if (key.isTotal == 1) {
                        this.totalField.push(key.fieldEntity)
                    }
                })
            });
            this.reportConditionVos.forEach((item) => {
                item.value = "";
                if (item.paramField != '' && item.paramField != 'null' && item.paramField != null) {
                    console.log(item.paramField)
                    this.initParamValue(item.paramField)
                }
                this.$set(this.getRequestData, item.fieldEntity, '')
                // 特定条件
                if (item.fieldEntity == "filter") {
                    this.getRequestData[item.fieldEntity] = JSON.parse(
                        item.formatterContent
                    )[0].value;
                }
                if (item.fieldEntity == "nearDays") {
                    this.getRequestData[item.fieldEntity] = 180;
                }
                if (item.fieldEntity == "opmName" && item.isShow == 1) {
                    this.isOpmParam = true
                }
                if (sessionStorage.getItem('printJurId') == '1636607096099') this.isJxqPrint = true
            });

            this.setTime();
        },
        setTime() {
            var day = JSON.parse(sessionStorage.getItem('printInfo')).days
            this.$set(
                this.getRequestData,
                "start",
                new Date(new Date().toLocaleDateString()).getTime() -
                day * 24 * 3600 * 1000
            );
            this.$set(
                this.getRequestData,
                "end",
                new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.fullscreenLoading = true
        this.getFormList();
    },
    mounted() { }, //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.$nextTick(() => {
            setTimeout(() => {
                const tableRefs = this.$refs['tableRef'];
                if (Array.isArray(tableRefs)) {
                    tableRefs.forEach((item) => {
                        item && item.doLayout && item.doLayout();
                    });
                } else if (tableRefs && tableRefs.doLayout) {
                    tableRefs.doLayout();
                }
            }, 16.7)
        })
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-drawer {
    outline: none;
}

.page_content {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
}

.page_content_top,
.module_toolbar {
    flex-shrink: 0;
}

.page_content_center {
    overflow-y: auto;
}

/* 对齐 v-tabs 工具栏主题 */
.module_toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 3px solid #e4e7ed;
    padding: 0 10px;
    min-height: 36px;
}

.module_toolbar_left {
    display: flex;
    align-items: center;
}

.report_name {
    font-size: 14px;
    color: #409eff;
    font-weight: 500;
    padding: 5px 0;
    border-bottom: 2px solid #409eff;
    margin-bottom: -2px;
}

.ul_btn {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.ul_btn li {
    display: inline-block;
    padding: 5px 3px;
    cursor: pointer;
}

.ul_btn li:hover {
    color: #409eff;
}

.icons {
    font-size: 18px;
    cursor: pointer;
}

.multi_module_wrap {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 10px;
}

.module_block {
    margin-bottom: 16px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 2px;
}

.module_block:last-child {
    margin-bottom: 0;
}

.module_block >>> .el-table,
.module_block >>> .u-table {
    height: auto !important;
}

.module_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    padding: 6px 12px;
}

.module_title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    position: relative;
    padding-left: 10px;
}

.module_title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 14px;
    background-color: #409eff;
    border-radius: 1px;
}

.module_count {
    font-size: 12px;
    color: #909399;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}

.page_content_top_line {
    padding-bottom: 0;
}
</style>
<style>
.el-table .red {
    background: #f5d3d3;
}

.el-table .yellow {
    background: #f5e4d3;
}
</style>